import { useEffect } from "react";
import {
  IMPORT_CATEGORIES_FROM_FILE,
  IMPORT_CLIENT_INFO,
  IMPORT_PRODUCTS_FROM_FILE,
} from "queries/neoFact/settings";
import { clientNeoFact, clientUploadNeoFact } from "@neonumy/api-clients";
import { onErrorGraphql } from "utils/onErrorGraphql";
import { useLazyQuery, useMutation } from "@apollo/client";
import { LIST_DEFAULT_FILES_TO_IMPORT } from "queries/centralApi/payments";

export default function useImportApi() {
  const [importProductsFromFile, { loading: importProductsFromFileLoading }] = useMutation<
    ImportProductsFromFileResponse,
    ImportProductsFromFileVars
  >(IMPORT_PRODUCTS_FROM_FILE, {
    client: clientUploadNeoFact,
  });

  const [importCategoriesFromFile, { loading: importCategoriesFromFileLoading }] = useMutation<
    ImportCategoriesFromFileResponse,
    ImportCategoriesFromFileVars
  >(IMPORT_CATEGORIES_FROM_FILE, {
    client: clientUploadNeoFact,
  });

  const [importClientInfo, { loading: importClientInfoLoading }] = useMutation<
    ImportClientInfoResponse,
    ImportClientInfoVars
  >(IMPORT_CLIENT_INFO, {
    client: clientUploadNeoFact,
  });

  const [
    listDefaultFilesToImport,
    {
      refetch: refetchListDefaultFilesToImport,
      loading: listDefaultFilesToImportLoading,
      data: listDefaultFilesToImportData,
      error: listDefaultFilesToImportError,
    },
  ] = useLazyQuery<ListDefaultFilesToImportResponse, ListDefaultFilesToImportVars>(
    LIST_DEFAULT_FILES_TO_IMPORT,
    {
      client: clientNeoFact,
      fetchPolicy: "no-cache",
    },
  );

  useEffect(() => {
    if (listDefaultFilesToImportError) onErrorGraphql(listDefaultFilesToImportError);
  }, [listDefaultFilesToImportError]);

  const listDefaultFiles: DefaultFileToImportResult[] =
    listDefaultFilesToImportData?.listDefaultFilesToImport?.results ?? [];

  return {
    importClientInfo,
    listDefaultFiles,
    importProductsFromFile,
    listDefaultFilesToImport,
    refetchListDefaultFilesToImport,
    listDefaultFilesToImportLoading,
    importClientInfoLoading,
    importCategoriesFromFile,
    importProductsFromFileLoading,
    importCategoriesFromFileLoading,
  };
}
